import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Stack, Typography, } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
// icons
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// utils and helpers
import { closeCustomModalDialog, setModalLoader } from '../../../redux/slices/modalSlice';
import { freezeDistribution, syncBlazeInventory } from "../../../redux/slices/hyperwolf/inventoryDistribution";
// custom components
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";
import MDButton from 'components/MDButton';

export default function FreezeDistribution({ closeModal }) {
  const dispatch = useDispatch()

  const { modalData = [], isLoading = false } = useSelector(state => state.modal);
  const { distributionBoxes = [], distributionId, handleRegionKits } = modalData || {}
  const [expanded, setExpanded] = useState(false);

  const handleExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleCloseModal = () => {
    closeModal(false);
  };

  const handleSave = async () => {
    if (isLoading) return;

    try {
      dispatch(setModalLoader(true));
      const response = await dispatch(freezeDistribution({ distributionId })).unwrap();

      if (response?.message) {
        // await dispatch(syncBlazeInventory({ currentEmployeeId: "5f9df52827e11708c30b7855" })).unwrap();

        showToastMsg(response?.message || "Success", "success");
        if (typeof handleRegionKits === "function") {
          handleRegionKits();
        }
      }
    } catch (error) {
      showToastMsg(error, "error")
    } finally {
      dispatch(setModalLoader(false));
      dispatch(closeCustomModalDialog());
    };
  }

  return (
    <>
      <DialogTitle className='p-4'>
        <Typography variant="h4" fontWeight="bold">
          Confirm Distribution
        </Typography>
        <IconButton onClick={handleCloseModal} edge='end' size='small' style={{ position: "absolute", right: "24px", top: "24px" }}>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>

      <DialogContent className='px-4 py-0'>
        <Typography variant="body2" sx={{ mb: 2, color: "#656575", fontSize: "16px" }}>
          Are you sure you want to freeze the  distribution?
        </Typography>
        <Box className="cus-contents cus-modal-contents">
          {/* Regions accordion */}
          {
            distributionBoxes?.map(data => (
              <Accordion key={data.regionId} className="cus-accordion-summary" expanded={expanded === data?.regionId} onChange={handleExpand(data?.regionId)}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <Typography>Region: {data?.regionName}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>

                    {/* Region Boxes */}
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        {
                          data?.boxes?.map(box => (
                            <Grid key={box?.boxId} item xs={12} md={4}>
                              <Box style={{ borderRadius: "8px", background: "#ffffff", padding: "14px", height: "100%" }}>
                                {box?.name && (
                                  <Typography variant='body2' fontWeight="semibold" color="#2E2E3A" mb={1}>
                                    {box.name}
                                  </Typography>
                                )}
                                <Typography variant='body2' fontWeight="medium" color="#656575" className='d-flex align-item-center jc-s-btwn gap-1 text-12'>
                                  <span>Qty Of Unique SKUs</span>
                                  <span>{box?.qtyOfUniqueSkus || 0}</span>
                                </Typography>
                                <Typography variant='body2' fontWeight="medium" color="#656575" className='d-flex align-item-center jc-s-btwn gap-1 text-12'>
                                  <span>Qty Of All Products</span>
                                  <span>{box?.qtyOfAllProducts || 0}</span>
                                </Typography>
                              </Box>
                            </Grid>
                          ))
                        }
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <hr className='my-1' style={{ borderTop: "1px solid #D0D0DA", borderBottom: "none", borderLeft: "none", borderRight: "none" }} />
                    </Grid>
                    <Grid item xs={12}>
                      <Stack direction="row" gap={2}>
                        <Typography variant='body2' fontWeight="medium" color="#2E2E3A">Kit Value: ${data?.wholesaleValue}</Typography>
                        {/* {
                          distributionConfigs?.isRetailer &&
                          <Typography variant='body2' fontWeight="medium" color="#2E2E3A">Retail: ${data?.retailValue}</Typography>
                        } */}
                      </Stack>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            ))
          }
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "start" }} className='p-4'>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25} mt={1}>
          <MDButton
            sx={{ minWidth: "150px" }}
            type="button"
            variant="contained"
            color="primary"
            disabled={isLoading}
            onClick={handleSave}
          >
            {isLoading ? <CircularProgress size={24} color="white" /> : "Yes, Distribute"}
          </MDButton>
          <MDButton
            sx={{ minWidth: "150px" }}
            type="button"
            variant="outlined"
            color="dark"
            onClick={handleCloseModal}
          >
            Cancel
          </MDButton>
        </Stack>
      </DialogActions>
    </>
  );
}